import { api, getApiErrorMessage, getApiErrorStatus } from './index';

export interface Departament {
  id: number;
  name: string;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateDepartamentData {
  name: string;
  description?: string;
}

export type UpdateDepartamentData = Partial<CreateDepartamentData>;

export class ApiError extends Error {
  statusCode?: number;
  constructor(message: string, statusCode?: number) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
  }
}

const baseUrl = '/departments';

export const departamentService = {
  async getAll(): Promise<Departament[]> {
    try {
      const response = await api.get(baseUrl);
      
      const items = response.data;
      
      if (!Array.isArray(items)) {
        throw new ApiError('Formato inesperado ao carregar departamentos');
      }
      
      return items;
    } catch (error) {
      console.error('Error in departamentService.getAll:', error);
      const statusCode = getApiErrorStatus(error);
      throw new ApiError(
        getApiErrorMessage(error, 'Erro ao carregar departamentos.'),
        statusCode,
      );
    }
  },

  async getById(id: number): Promise<Departament> {
    const response = await api.get(`${baseUrl}/${id}`);
    return response.data.data || response.data;
  },

  async create(data: CreateDepartamentData): Promise<Departament> {
    const response = await api.post(baseUrl, data);
    return response.data.data || response.data;
  },

  async update(id: number, data: UpdateDepartamentData): Promise<Departament> {
    const response = await api.put(`${baseUrl}/${id}`, data);
    return response.data.data || response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`${baseUrl}/${id}`);
  },
};
